type Props = {
  color?: string;
};

export default function LocationPin({
  color = "var(--brand-primary-color)",
}: Props) {
  return (
    <svg
      width="32"
      height="44"
      viewBox="0 0 32 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 0C7.15429 0 0 6.886 0 15.4C0 26.95 16 44 16 44C16 44 32 26.95 32 15.4C32 6.886 24.8457 0 16 0ZM16 20.9C12.8457 20.9 10.2857 18.436 10.2857 15.4C10.2857 12.364 12.8457 9.9 16 9.9C19.1543 9.9 21.7143 12.364 21.7143 15.4C21.7143 18.436 19.1543 20.9 16 20.9Z"
        fill={color}
      />
    </svg>
  );
}
